module.exports = __webpack_public_path__ + "static/media/pick-up-delivery_2.6c13cb42.svg";